import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { HYDRATE } from 'next-redux-wrapper'

import { RootState } from '@/redux/store/configureStore'
import { ITrackingSearchState } from './type'

const initialState = {
    data: {} as ITrackingSearchState
}

export const trackingSearchSlice = createSlice({
    name: 'trackingSearch',
    initialState,
    reducers: {
        setTrackingSearchState: (state, action: PayloadAction<Partial<ITrackingSearchState>>) => {
            const { payload } = action || {}
            state.data = { ...state.data, ...payload }
        },
        resetTrackingSearchState: (state) => {
            state.data = {} as ITrackingSearchState
        }
    },
    extraReducers: builder => {
        builder.addCase(HYDRATE, (state, action) => {
            // Preserve client state during hydration, only use server state if client is empty
            const serverState = (action.payload as any)?.trackingSearch?.data
            if (serverState && Object.keys(state.data).length === 0) {
                state.data = serverState
            }
        })
    }
})

const { reducer, actions } = trackingSearchSlice
const { setTrackingSearchState, resetTrackingSearchState } = actions || {}

export const getTrackingSearchState = (state: RootState) => state.trackingSearch.data

export { setTrackingSearchState, resetTrackingSearchState }

export default reducer
